/**
 * DataTableCellView class
 *
 * @package    DataTable
 * @author     Dmytro Ieremenko <dieremenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DataTableColumnType, DataTableItemType } from 'Types';
import { withRouter } from 'react-router-dom';
import Button from 'Common/CustomButtons/Button';
import { FormattedMessage } from 'react-intl';

class DataTableCellView extends PureComponent {

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    /**
     * PropTypes
     */
    static propTypes = {
        column: DataTableColumnType,
        value: PropTypes.any,
        history: PropTypes.any,
        item: DataTableItemType.isRequired,
    };

    /**
     * Handle Click
     */
    handleClick = () => {
        const { history } = this.props;
        const link = this.getLink();
        history.push(link);
    };

    /**
     * Get Link
     */
    getLink = () => {
        const { item, column } = this.props;
        const { placeholders } = column.link;
        let { to } = column.link;
        if (placeholders) {
            for (let name in placeholders) {
                if (placeholders.hasOwnProperty(name)) {
                    to = to.replace(
                        `:${name}`,
                        typeof placeholders[name] === 'function'
                            ? placeholders[name](item)
                            : placeholders[name]
                    );
                }
            }
        }

        return to;
    };

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        return (
            <div>
                <Button color='info' onClick={this.handleClick}><FormattedMessage id='button.view'/></Button>
            </div>
        );
    }
}

export default withRouter(DataTableCellView);



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableBody/DataTableCells/DataTableCellView.jsx